export default __webpack_public_path__ + "static/media/Night_00.d30a4e70.png";